import { Store, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import InstagramGalleryEntity from "../entities/InstagramGalleryEntity";

export interface InstagramGalleryState {
    gallery: InstagramGalleryEntity | null;
}

export function createInitialState(): InstagramGalleryState {
    return {
        gallery: null,
    };
}

@singleton()
@StoreConfig({ name: "instagram-galleries" })
class InstagramGalleriesStore extends Store<InstagramGalleryState> {
    constructor() {
        super(createInitialState());
    }
}

export default InstagramGalleriesStore;
